import React, { useState, useEffect, useRef } from 'react';
import { MenuIcon } from './icons/MenuIcon';
import { AdminIcon } from './icons/AdminIcon';
import { SettingsIcon } from './icons/SettingsIcon';

interface DropdownMenuProps {
    onNavigateToDataManagement?: () => void;
    onNavigateToAppSettings?: () => void;
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ onNavigateToDataManagement, onNavigateToAppSettings }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleDataManagementClick = () => {
        if (onNavigateToDataManagement) onNavigateToDataManagement();
        setIsOpen(false);
    }
    
    const handleAppSettingsClick = () => {
        if (onNavigateToAppSettings) onNavigateToAppSettings();
        setIsOpen(false);
    }

    return (
        <div className="relative" ref={menuRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-full hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                <MenuIcon className="w-5 h-5 text-gray-600" />
            </button>

            {isOpen && (
                <div
                    className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                >
                    <div className="py-1" role="none">
                         <button
                            onClick={handleDataManagementClick}
                            className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center gap-3"
                            role="menuitem"
                        >
                            <AdminIcon className="w-5 h-5" />
                            Správa dat
                        </button>
                        <button
                            onClick={handleAppSettingsClick}
                            className="text-gray-700 block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 flex items-center gap-3"
                            role="menuitem"
                        >
                            <SettingsIcon className="w-5 h-5" />
                            Nastavení aplikace
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
